/* ==========================================================================
   CREALIS — JavaScript del home (mínimo y sin librerías)
   1) Animación de entrada del hero (saltable, corta, accesible)
   2) Aparición suave de elementos al hacer scroll
   3) Flechas de los carruseles de producto (solo escritorio)
   Si este archivo no carga, la página se ve completa igual.
   ========================================================================== */
(function () {
  'use strict';

  // Evita ejecutarse dos veces (cada sección incluye este archivo)
  if (window.__crealisHome) return;
  window.__crealisHome = true;

  var pocaAnimacion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Marca que hay JS: el CSS solo esconde elementos "reveal" si existe esta clase
  document.documentElement.classList.add('cr-js');

  /* ---------- 1. Animación de entrada del hero ---------- */
  function initHero() {
    var hero = document.querySelector('[data-cr-hero]');
    if (!hero || hero.classList.contains('cr-anim')) return;
    if (pocaAnimacion || hero.dataset.crAnimar === 'false') return;

    hero.classList.add('cr-anim');

    // Un toque/click en cualquier parte salta la animación
    var saltar = function () { hero.classList.add('cr-anim-fin'); };
    document.addEventListener('pointerdown', saltar, { once: true, passive: true });
    // Y a los 950 ms se da por terminada sola (limpieza)
    setTimeout(saltar, 950);
  }

  /* ---------- 2. Aparición al hacer scroll ---------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.cr-reveal:not(.cr-visible)');
    if (!elementos.length) return;

    if (pocaAnimacion || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('cr-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('cr-visible');
          observador.unobserve(entrada.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- 3. Flechas de carrusel ---------- */
  function initCarriles() {
    document.querySelectorAll('[data-cr-carril]').forEach(function (seccion) {
      if (seccion.dataset.crListo) return;
      seccion.dataset.crListo = 'true';

      var carril = seccion.querySelector('.cr-fila__carril');
      var atras = seccion.querySelector('[data-cr-atras]');
      var adelante = seccion.querySelector('[data-cr-adelante]');
      if (!carril || !atras || !adelante) return;

      function estado() {
        var max = carril.scrollWidth - carril.clientWidth;
        // Si no hay nada que deslizar, se esconden las flechas
        var flechas = seccion.querySelector('.cr-fila__flechas');
        if (flechas) flechas.style.display = max < 10 ? 'none' : '';
        atras.disabled = carril.scrollLeft <= 4;
        adelante.disabled = carril.scrollLeft >= max - 4;
      }

      function mover(direccion) {
        carril.scrollBy({
          left: direccion * carril.clientWidth * 0.85,
          behavior: pocaAnimacion ? 'auto' : 'smooth'
        });
      }

      atras.addEventListener('click', function () { mover(-1); });
      adelante.addEventListener('click', function () { mover(1); });
      carril.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  /* ---------- 4. La mascota sigue el mouse ----------
     - Capas con data-cr-parallax se desplazan suavecito hacia el cursor.
     - Las pupilas [data-cr-pupila] miran hacia el mouse (rango cortito,
       para que se vea vivo y no bizco). ---------- */
  function initParallax() {
    if (pocaAnimacion) return;
    // Solo con mouse real (en celular no tiene sentido)
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var elementos = document.querySelectorAll('[data-cr-parallax]');
    var pupilas = document.querySelectorAll('[data-cr-pupila]');
    if ((!elementos.length && !pupilas.length) || window.__crealisParallax) return;
    window.__crealisParallax = true;

    var objetivoX = 0, objetivoY = 0, actualX = 0, actualY = 0, animando = false;

    function animar() {
      // Se acerca suavecito al objetivo (efecto "vivo", no robótico)
      actualX += (objetivoX - actualX) * 0.08;
      actualY += (objetivoY - actualY) * 0.08;

      elementos.forEach(function (el) {
        var fuerza = parseFloat(el.dataset.crParallax) || 12;
        el.style.translate = (actualX * fuerza) + 'px ' + (actualY * fuerza) + 'px';
      });

      pupilas.forEach(function (p) {
        // La pupila se mueve dentro del ojo: máximo ~30% del ancho del ojo
        var ojo = p.parentElement;
        var max = (ojo ? ojo.clientWidth : 14) * 0.3;
        p.style.translate = (actualX * 2 * max) + 'px ' + (actualY * 2 * max) + 'px';
      });

      if (Math.abs(objetivoX - actualX) > 0.001 || Math.abs(objetivoY - actualY) > 0.001) {
        requestAnimationFrame(animar);
      } else {
        animando = false;
      }
    }

    document.addEventListener('mousemove', function (e) {
      objetivoX = (e.clientX / window.innerWidth) - 0.5;
      objetivoY = (e.clientY / window.innerHeight) - 0.5;
      if (!animando) { animando = true; requestAnimationFrame(animar); }
    }, { passive: true });
  }

  /* ---------- 5. Lumo sigue el mouse: secuencia de cuadros en canvas ----------
     Técnica estilo Apple: en vez de mover un video (lento de buscar), se
     precargan ~61 fotos JPG del giro de cabeza y se dibuja la que corresponde
     a la posición del mouse sobre un canvas. Resultado: fluido de verdad.
     En pantallas táctiles se reproduce el video ida-y-vuelta en loop. ---------- */
  function initScrub() {
    var lienzo = document.querySelector('[data-cr-lienzo]');
    var datos = document.querySelector('[data-cr-cuadros]');
    var videoTactil = document.querySelector('[data-cr-video-tactil]');

    var interactivo = !pocaAnimacion &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.innerWidth >= 750;

    // Táctil: loop ida-y-vuelta normal
    if (videoTactil && !interactivo) {
      var p = videoTactil.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!lienzo || !datos || !interactivo || lienzo.dataset.crListo) return;
    lienzo.dataset.crListo = 'true';

    var urls = [];
    try { urls = JSON.parse(datos.textContent); } catch (err) { return; }
    var total = urls.length;
    if (!total) return;

    var ctx = lienzo.getContext('2d');
    var cuadros = new Array(total);
    var cargados = 0, listo = false;
    var idxActual = (total - 1) / 2, idxObjetivo = idxActual, dibujado = -1;
    var ultimaMano = 0; // última vez que se movió el mouse

    function medir() {
      var caja = lienzo.parentElement.getBoundingClientRect();
      // Tope de resolución interna para no sobrecargar GPUs modestas
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      lienzo.width = Math.round(caja.width * dpr);
      lienzo.height = Math.round(caja.height * dpr);
      dibujado = -1;
      pintar(Math.round(idxActual));
    }

    function pintar(i) {
      var img = cuadros[i];
      if (!img || !img.complete || dibujado === i) return;
      // Recorte tipo "cover": la foto llena el canvas sin deformarse
      var cw = lienzo.width, ch = lienzo.height;
      var esc = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      var dw = img.naturalWidth * esc, dh = img.naturalHeight * esc;
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
      dibujado = i;
    }

    function anima(ahora) {
      // ¿Mouse quieto hace más de 1.6s? Lumo "vive" sola: la mirada deambula
      // suavecito alrededor del último punto (y con ella se mueven las
      // chispitas y la niebla de la escena — nunca se ve congelada).
      var enReposo = (ahora - ultimaMano) > 1600;
      var objetivo = idxObjetivo;
      if (enReposo) {
        objetivo = idxObjetivo + Math.sin(ahora / 1500) * 2.6 + Math.sin(ahora / 470) * 0.4;
      }
      if (objetivo < 0) objetivo = 0;
      if (objetivo > total - 1) objetivo = total - 1;

      // Con mouse activo gira ágil; en reposo, lento como respirando
      idxActual += (objetivo - idxActual) * (enReposo ? 0.04 : 0.14);
      pintar(Math.round(idxActual));
      requestAnimationFrame(anima);
    }

    urls.forEach(function (u, i) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        cargados++;
        if (!listo && cargados >= total) {
          listo = true;
          medir();
          lienzo.classList.add('cr-lienzo-listo');
          window.addEventListener('resize', medir);
          requestAnimationFrame(anima); // bucle permanente: Lumo nunca se congela
        }
      };
      img.src = u;
      cuadros[i] = img;
    });

    document.addEventListener('mousemove', function (e) {
      // Mouse a la izquierda = mira a la izquierda; a la derecha = a la derecha
      idxObjetivo = (e.clientX / window.innerWidth) * (total - 1);
      ultimaMano = performance.now();
    }, { passive: true });
  }

  /* ---------- 6. Mundo por capas: profundidad con scroll + mouse ----------
     Cada capa con data-cr-profundidad se desplaza a su propia velocidad:
     el cielo casi se queda quieto, la pradera avanza, las chispitas se
     mueven en contra. El ojo lee eso como profundidad 3D real.
     El scroll aplica directo (barato: solo transforms); el rAF se usa
     solo para suavizar el mouse. ---------- */
  function initMundo() {
    var capas = document.querySelectorAll('[data-cr-profundidad]');
    if (!capas.length || window.__crealisMundo) return;
    window.__crealisMundo = true;
    if (pocaAnimacion) return;

    var mx = 0, my = 0, objX = 0, objY = 0, suavizando = false;

    function aplicar() {
      var sc = window.scrollY || document.documentElement.scrollTop || 0;
      capas.forEach(function (el) {
        var d = parseFloat(el.dataset.crProfundidad) || 0;
        el.style.transform = 'translate3d(' + (mx * d * 26).toFixed(1) + 'px,' + (sc * d + my * d * 16).toFixed(1) + 'px,0)';
      });
    }

    function suavizar() {
      mx += (objX - mx) * 0.08;
      my += (objY - my) * 0.08;
      aplicar();
      if (Math.abs(objX - mx) > 0.002 || Math.abs(objY - my) > 0.002) {
        requestAnimationFrame(suavizar);
      } else {
        suavizando = false;
      }
    }

    window.addEventListener('scroll', aplicar, { passive: true });
    window.addEventListener('resize', aplicar, { passive: true });
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mousemove', function (e) {
        objX = (e.clientX / window.innerWidth - 0.5) * 2;
        objY = (e.clientY / window.innerHeight - 0.5) * 2;
        if (!suavizando) { suavizando = true; requestAnimationFrame(suavizar); }
      }, { passive: true });
    }
    aplicar();
  }

  /* ---------- 7. Chispitas doradas del mundo (canvas) ----------
     Particulas que flotan hacia arriba con parpadeo suave. Se pausan
     solas cuando el hero sale de pantalla o la pestana se esconde. ---------- */
  function initChispas() {
    var cv = document.querySelector('[data-cr-chispas]');
    if (!cv || cv.dataset.crListo || pocaAnimacion) return;
    cv.dataset.crListo = 'true';
    var ctx = cv.getContext('2d');
    if (!ctx) return;

    var W = 0, H = 0, particulas = [], raf = null, visible = true;
    var dpr = Math.min(2, window.devicePixelRatio || 1);

    function medir() {
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = Math.max(1, W * dpr); cv.height = Math.max(1, H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    /* Sprites pre-dibujados: el brillo (shadowBlur) se pinta UNA sola vez
       aqui, no en cada frame por particula — sin esto la pagina se laquea. */
    function sprite(tono) {
      var s = document.createElement('canvas');
      s.width = 32; s.height = 32;
      var sc = s.getContext('2d');
      var g = sc.createRadialGradient(16, 16, 0, 16, 16, 16);
      g.addColorStop(0, 'rgba(' + tono + ',1)');
      g.addColorStop(0.35, 'rgba(' + tono + ',0.5)');
      g.addColorStop(1, 'rgba(' + tono + ',0)');
      sc.fillStyle = g;
      sc.fillRect(0, 0, 32, 32);
      return s;
    }
    var sprites = [sprite('255,214,122'), sprite('255,246,220')];

    function nueva() {
      return {
        x: Math.random() * W, y: H + Math.random() * H * 0.3,
        r: 2.2 + Math.random() * 5.5, v: 0.1 + Math.random() * 0.4,
        f: Math.random() * 6.28, a: 0.12 + Math.random() * 0.5,
        s: sprites[Math.random() < 0.5 ? 0 : 1]
      };
    }
    function poblar() {
      medir(); particulas = [];
      var n = Math.max(14, Math.round(W / 22));
      for (var i = 0; i < n; i++) { var p = nueva(); p.y = Math.random() * H; particulas.push(p); }
    }
    function dibujar() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < particulas.length; i++) {
        var p = particulas[i];
        p.y -= p.v; p.f += 0.012; p.x += Math.sin(p.f) * 0.3;
        if (p.y < -8) { particulas[i] = nueva(); continue; }
        ctx.globalAlpha = p.a * (0.6 + 0.4 * Math.sin(p.f * 2));
        ctx.drawImage(p.s, p.x - p.r, p.y - p.r, p.r * 2, p.r * 2);
      }
      ctx.globalAlpha = 1;
      raf = visible && !document.hidden ? requestAnimationFrame(dibujar) : null;
    }
    function arrancar() { if (!raf && visible && !document.hidden) raf = requestAnimationFrame(dibujar); }
    function parar() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        visible ? arrancar() : parar();
      }, { threshold: 0.02 }).observe(cv);
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? parar() : arrancar(); });
    window.addEventListener('resize', poblar);
    poblar(); arrancar();
  }

  function init() {
    initHero();
    initReveals();
    initCarriles();
    initParallax();
    initScrub();
    initMundo();
    initChispas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dentro del editor de Shopify las secciones se recargan sin refrescar la
  // página: volvemos a inicializar lo que haga falta.
  document.addEventListener('shopify:section:load', init);
})();
